module.exports = __webpack_public_path__ + "static/media/about-01.bcae75ea.png";